/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useRef } from "react";
import { Link } from "react-router-dom"; // CHANGED FROM NEXT/LINK
import { motion, AnimatePresence } from "framer-motion";

export default function Home() {
  const strengthRef = useRef(null);
  const [openFaq, setOpenFaq] = useState(null);

  // --- DATA ARRAYS ---
  const trustPillars = [
    { title: "15+ Years Excellence", desc: "A decade and a half of delivering top-tier IT infrastructure across Raipur.", icon: "M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.562.562 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z" },
    { title: "Authorized Partner", desc: "Direct tie-ups with global giants like HP, Dell, ASUS, and Lenovo.", icon: "M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 01-1.043 3.296 3.745 3.745 0 01-3.296 1.043A3.745 3.745 0 0112 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 01-3.296-1.043 3.745 3.745 0 01-1.043-3.296A3.745 3.745 0 013 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 011.043-3.296a3.746 3.746 0 013.296-1.043A3.746 3.746 0 0112 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 013.296 1.043a3.746 3.746 0 011.043 3.296A3.745 3.745 0 0121 12z" },
    { title: "Certified Support", desc: "In-house certified technicians providing 24/7 B2B technical assistance.", icon: "M11.423 20.407c.56.198 1.154.198 1.714 0l7.355-2.6a2.25 2.25 0 001.272-2.042V8.402a2.25 2.25 0 00-1.272-2.042l-7.355-2.6a2.25 2.25 0 00-1.714 0L4.068 6.36a2.25 2.25 0 00-1.272 2.042v7.363c0 .975.63 1.839 1.272 2.042l7.355 2.6z" },
    { title: "10k+ Happy Clients", desc: "Serving thousands of individual users and 500+ corporate offices.", icon: "M15.75 9a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" },
  ];

  const b2bServices = [
    { title: "Product Sales & Procurement", desc: "Single source for high-quality IT hardware. Leading brands of servers, desktops, and security.", image: "https://ik.imagekit.io/igxrggga8/pcworldraipur.in/Banners%20frontsite/Professional%20IT%20System%20Services.png", tag: "Hardware" },
    { title: "Professional IT Systems", desc: "Expert deployment and optimization including LAN/WAN and cloud integration.", image: "https://images.unsplash.com/photo-1551739440-5dd934d3a94a?q=80&w=800", tag: "Integration" },
    { title: "Maintenance & AMC Support", desc: "Proactive support to guarantee maximum uptime with on-demand hardware repair.", image: "https://images.unsplash.com/photo-1581092160562-40aa08e78837?q=80&w=800", tag: "Support" },
  ];

  const strengths = [
    { title: "10+ Years Raipur B2B", desc: "Deep market trust and proven, long-term commitment to client success and satisfaction.", color: "text-red-600", bg: "bg-red-50" },
    { title: "High-level Technicians", desc: "Ensure rapid, accurate, and expert IT system maintenance and troubleshooting.", color: "text-blue-600", bg: "bg-blue-50" },
    { title: "Complete Inventory", desc: "From servers to security—meets every complex corporate IT infrastructure requirement efficiently.", color: "text-green-600", bg: "bg-green-50" },
    { title: "Prompt After-Sales", desc: "Guarantees minimal business downtime, maximizing operational continuity for all corporate customers.", color: "text-purple-600", bg: "bg-purple-50" },
  ];

  const faqs = [
    { q: "How does your 10 years experience benefit my business's IT needs?", a: "A decade of experience means we have built deep-rooted relationships with global vendors like HP and Dell, ensuring you get factory-direct pricing and reliable advice." },
    { q: "What specific B2B products and services does PC World Raipur provide?", a: "We provide enterprise servers, high-performance workstations, networking equipment, and security firewalls tailored for corporate infrastructures." },
    { q: "Are your IT technicians highly certified and experienced in corporate systems?", a: "Yes, our team consists of OEM-certified professionals specializing in complex server environments and network security." },
    { q: "Can you handle large-scale IT infrastructure setup and support?", a: "We specialize in end-to-end deployment for offices, schools, and manufacturing units, including ongoing AMC support." },
    { q: "What makes PC World the best choice for B2B technology partners in Raipur?", a: "We combine national-level pricing with rapid, personalized local support that national chains cannot match." }
  ];

  const scrollStrengths = (dir) => {
    strengthRef.current.scrollBy({ left: dir === "left" ? -400 : 400, behavior: "smooth" });
  };

  return (
    <div className="w-full bg-white text-slate-900">
      
      {/* 1. HERO SECTION - Fixed for React App */}
      <section className="relative h-screen w-full flex items-center justify-center overflow-hidden -mt-24 md:-mt-32">
        <div className="absolute inset-0 z-0">
         {/* DESKTOP VIEW: Local Image */}
<div 
  className="hidden md:block w-full h-full bg-cover bg-center" 
  style={{ backgroundImage: `url('/assets/all/ds.webp')` }} 
/>

{/* MOBILE VIEW: Local Image */}
<div 
  className="block md:hidden w-full h-full bg-cover bg-center" 
  style={{ backgroundImage: `url('/assets/all/mb.webp')` }} 
/>

{/* Overlay */}
<div className="absolute inset-0 bg-black/40" />
        </div>
        
        <div className="relative z-10 text-center px-6 mt-16 md:mt-20">
          <motion.h1 
            initial={{ opacity: 0, scale: 0.9 }} 
            animate={{ opacity: 1, scale: 1 }} 
            className="text-5xl md:text-8xl font-black text-white mb-6 uppercase tracking-tighter leading-none"
          >
            PC WORLD <br className="md:hidden" /> <span className="text-blue-500">RAIPUR</span>
          </motion.h1>
        <p className="text-gray-200 text-[26px] max-w-xs mx-auto mb-9 font-semibold"> PC World — your trusted IT partner for smart solutions across various field.</p>

          <p className="text-gray-200 text-sm md:text-2xl max-w-2xl mx-auto mb-10 font-bold uppercase tracking-[0.3em]">
            Premium B2B IT Solutions
          </p>
          <Link to="/contact" className="bg-blue-600 text-white px-10 py-4 rounded-xl font-black uppercase tracking-widest text-xs hover:bg-white hover:text-blue-600 transition-all shadow-2xl inline-block">
            Consult Our Experts
          </Link>
        </div>
      </section>

      {/* 2. LET'S KNOW US (Video Section) */}
      <section className="py-24 px-6 max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl md:text-6xl font-black mb-8 uppercase italic leading-none">Let's <span className="text-blue-600">Know Us</span></h2>
            <p className="text-xl text-gray-600 leading-relaxed mb-8 font-medium">We empower Raipur's digital landscape with high-end server configurations and custom-built tech infrastructure for corporate excellence.</p>
            <div className="space-y-4 font-black text-slate-800 tracking-tight text-sm">
              <p className="flex items-center gap-3"><span className="text-blue-600">✓</span> CERTIFIED B2B HARDWARE</p>
              <p className="flex items-center gap-3"><span className="text-blue-600">✓</span> EXPERT TECHNICAL SUPPORT</p>
              <p className="flex items-center gap-3"><span className="text-blue-600">✓</span> OPTIMIZED IT SOLUTIONS</p>
            </div>
          </div>
          <div className="rounded-[2.5rem] overflow-hidden shadow-2xl bg-black aspect-video border-[12px] border-slate-50">
            <video autoPlay muted loop playsInline className="w-full h-full object-cover">
              <source src="https://ik.imagekit.io/igxrggga8/pcworldraipur.in/vd.mp4" type="video/mp4" />
            </video>
          </div>
        </div>
      </section>

      {/* 3. TRUST PILLARS */}
      <section className="py-24 bg-slate-50 px-6">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {trustPillars.map((p, i) => (
            <div key={i} className="bg-white p-8 rounded-[2rem] shadow-sm border border-slate-100 group hover:border-blue-200 transition-colors">
              <div className="w-12 h-12 bg-blue-50 text-blue-600 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-blue-600 group-hover:text-white transition-all">
                <svg fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-6 h-6"><path d={p.icon} /></svg>
              </div>
              <h3 className="text-lg font-black mb-2 uppercase tracking-tight">{p.title}</h3>
              <p className="text-slate-500 text-sm font-medium leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* 4. CORE B2B SOLUTIONS */}
      <section className="py-24 bg-slate-950 text-white px-6">
        <div className="max-w-7xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-6xl font-black uppercase tracking-tighter">Core B2B <span className="text-blue-500 italic">Solutions</span></h2>
        </div>
        <div className="max-w-7xl mx-auto grid lg:grid-cols-3 gap-10">
          {b2bServices.map((s, i) => (
            <div key={i} className="bg-white rounded-[2.5rem] overflow-hidden group">
              <div className="h-64 overflow-hidden relative">
                <img src={s.image} className="w-full h-full object-cover group-hover:scale-110 transition duration-700 opacity-90 group-hover:opacity-100" alt={s.title} />
                <span className="absolute top-6 left-6 bg-blue-600 text-white px-4 py-1.5 rounded-full text-[10px] font-black uppercase tracking-widest">{s.tag}</span>
              </div>
              <div className="p-10 text-slate-900">
                <h3 className="text-2xl font-black mb-4 uppercase tracking-tight">{s.title}</h3>
                <p className="text-slate-600 font-medium mb-8 leading-relaxed text-sm">{s.desc}</p>
                <Link to="/contact" className="inline-block bg-slate-900 text-white px-6 py-3 rounded-xl text-[10px] font-black uppercase tracking-widest hover:bg-blue-600 transition-colors">Inquire Now</Link>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* 5. STRENGTH SLIDER */}
      <section className="py-24 px-6 overflow-hidden">
        <div className="max-w-7xl mx-auto flex justify-between items-end mb-12">
          <h2 className="text-4xl md:text-6xl font-black uppercase tracking-tighter leading-none">KEY <br /> <span className="text-blue-600 italic">STRENGTH</span></h2>
          <div className="flex gap-3">
            <button onClick={() => scrollStrengths("left")} className="w-12 h-12 flex items-center justify-center bg-slate-100 rounded-full hover:bg-blue-600 hover:text-white transition">←</button>
            <button onClick={() => scrollStrengths("right")} className="w-12 h-12 flex items-center justify-center bg-slate-100 rounded-full hover:bg-blue-600 hover:text-white transition">→</button>
          </div>
        </div>
        <div ref={strengthRef} className="flex overflow-x-auto gap-8 no-scrollbar scroll-smooth snap-x snap-mandatory px-4">
          {strengths.map((s, i) => (
            <div key={i} className="flex-shrink-0 w-[85vw] md:w-[450px] snap-center p-12 rounded-[3rem] bg-slate-50 border border-slate-100 group hover:bg-blue-600 transition duration-500">
              <div className={`w-14 h-14 ${s.bg} ${s.color} rounded-2xl mb-8 flex items-center justify-center font-black group-hover:bg-white transition-all`}>★</div>
              <h3 className="text-2xl font-black mb-4 uppercase group-hover:text-white transition tracking-tighter">{s.title}</h3>
              <p className="text-slate-500 font-medium group-hover:text-white/80 transition text-sm leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* 6. FAQ */}
      <section className="py-24 px-6 bg-slate-50">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl md:text-6xl font-black text-center mb-16 uppercase tracking-tighter leading-none">Frequently Asked <br /> <span className="text-blue-600 italic">Questions</span></h2>
          <div className="space-y-4">
            {faqs.map((f, i) => (
              <div key={i} className="bg-white rounded-3xl overflow-hidden border border-slate-200">
                <button onClick={() => setOpenFaq(openFaq === i ? null : i)} className="w-full flex items-center justify-between p-8 text-left transition hover:bg-slate-50/50">
                  <span className="text-lg font-black text-slate-800 pr-4 uppercase tracking-tight leading-tight">{f.q}</span>
                  <span className={`text-2xl transition duration-500 ${openFaq === i ? 'rotate-45 text-blue-600' : 'text-slate-300'}`}>+</span>
                </button>
                <AnimatePresence>
                  {openFaq === i && (
                    <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} className="overflow-hidden">
                      <p className="p-8 pt-0 text-md text-slate-500 font-medium border-t border-slate-50 leading-relaxed italic">{f.a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
}